
import { FormattedMessage } from 'react-intl';
import { Link, useHistory } from 'react-router-dom';
import { isEmpty } from 'lodash';

import { VACATIONS_PAGE, getAccountUsernameFromPath } from '@share/utils';
import { BlueButton } from '@share/components';
import { Routes } from '@share/constants';
import { WhiteButton } from '@components';

import NotAvailable from '@assets/images/availability-status.png';

import './style.scss';

interface IProps {
  isFromCondo?: boolean;
  isVacationRentals?: boolean;
  isReviewBook?: boolean;
  isExpiredSession?: boolean;
  propertyId?: string;
  sessionId: string;
}

export function AvailabilityError(props: IProps) {
  const { isFromCondo = false, isReviewBook = false, propertyId, isVacationRentals, sessionId, isExpiredSession } = props;

  const history = useHistory();

  const accountName = getAccountUsernameFromPath(history);

  const url = isFromCondo ? 
                  isReviewBook ?
                        `/${accountName}${Routes.UnitBook}/${propertyId}${location.search}` :
                        `/${accountName}${Routes.CondoSearch}${location.search}` :
                  isVacationRentals ? 
                        `/${accountName}${Routes.Search}/${VACATIONS_PAGE}${location.search}` :
                        `/${accountName}${Routes.Search}${location.search}`;

  const detailUrl = isReviewBook ? 
                            isFromCondo ? 
                                `/${accountName}${Routes.Condo}/${propertyId}${location.search}` : 
                                `/${accountName}${Routes.Hotel}/${propertyId}${location.search}` : 
                            undefined;

  return (
    <div className="availability-error">
      <img src={NotAvailable} alt="" />
      <p className="availability-error__title secondary-font">
        <FormattedMessage id={isExpiredSession ? 'expired.session' : 'unit.is.no.available'} />
      </p>

      <p className="availability-error__description">
        {!isExpiredSession ? (
          <FormattedMessage id={isFromCondo ? 'condo.unit.selected.no.longer.available' : 'unit.selected.no.longer.available'} />) : (
          <FormattedMessage id={isFromCondo ? 'check.unit.availability' : 'check.room.availability'} />)}

        {!isEmpty(sessionId) && (
          <span style={{ marginTop: '15px', fontSize: '12px' }}>
            <FormattedMessage id="session.id" values={{ sessionId }} />
          </span>)}
      </p>

      
      <div className="availability-error__btn-wrapper">
        <Link to={url}>
          <BlueButton>
            <FormattedMessage id={isFromCondo ? 'search.condos' : 'search.hotel'} />
          </BlueButton>
        </Link>
      </div>

      {isReviewBook && detailUrl && !isExpiredSession && (
        <div className="availability-error__btn-wrapper" style={{ marginTop: '20px' }}>
          <Link to={detailUrl}>
            <WhiteButton>
              <FormattedMessage id="availability.status.modal.back_detail" />
            </WhiteButton>
          </Link>
        </div>)}
    </div>
  );
}
